import React from 'react'

import HeaderContainer from 'components/Shared/ActionCard/Header'
import ContentContainer from 'components/Shared/ActionCard/Content'
import FooterContainer from 'components/Shared/ActionCard/Footer'
import { Wrapper } from 'components/Shared/ActionCard/Helper'
import { ActionCardProps } from 'types/TextAnalysis'
import { generateCardProps } from 'components/Shared/ActionCard/PropsGenerator'

const ActionCard = (props: ActionCardProps) => {
  const { wrapperProps, headerProps, contentProps, footerProps, cardTagMenu } =
    generateCardProps(props)

  return (
    <Wrapper {...wrapperProps}>
      <>
        <HeaderContainer {...headerProps} />
        <ContentContainer {...contentProps} />
        <FooterContainer {...footerProps} />
        {cardTagMenu}
      </>
    </Wrapper>
  )
}

export default React.memo(ActionCard)
